import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setSelectedCandidates } from '../actions/selected-candidates.actions';
import { Candidate } from '../models/candidate.model';

export const initialState: Candidate[] = [];

const reducer = createReducer(initialState,
  on(setSelectedCandidates, (state, { selectedCandidates }) => selectedCandidates)
);

export const fromSelectedCandidates = {
  selectSelectedCandidatesState: createFeatureSelector<Candidate[]>('selectedCandidates'),
};

export function selectedCandidatesReducer(state, action) {
  return reducer(state, action);
}
